export const accountCalculationQueryKeys = {
  all: [{ scope: 'accountCalculation' }] as const,
  lists: () => [{ ...accountCalculationQueryKeys.all[0], entity: 'list' }] as const,
  list: (context: { companyId?: string | null }) =>
    [{ ...accountCalculationQueryKeys.lists()[0], ...context }] as const,
  details: () => [{ ...accountCalculationQueryKeys.all[0], entity: 'detail' }] as const,
  detail: (context: { companyId?: string | null }, id: number) =>
    [{ ...accountCalculationQueryKeys.details()[0], ...context, id }] as const
}
